import { apiClient } from "../apiClient";
import { apiConnector } from "../apiConnector";
import toast from "react-hot-toast";

export function Post_Feedback(formData){
    const token = localStorage.getItem('token')
    return async(dispatch)=>{
        try {
            const response = await apiConnector("POST",apiClient.POST_FEEDBACK,formData,{
                Authorization:`Bearer ${token}`
            })
            if(!response?.data?.success){
                throw new Error(response?.data?.message)
            }
            toast.success(response?.data?.message)
            return response?.data
        } catch (error) {
            const message = error?.response?.data?.message||error?.message
            console.log("Internal Client Error:",message)
            return error?.response?.data
        }
    }
}